import { useOperationStore } from '@/store/storeOperation';

/**
 * Thin wrapper around `fetch` that injects the same auth + operation headers
 * the Apollo GraphQL client uses. For non-GraphQL REST endpoints (e.g. the
 * Chorus assistant `/api/chat`, the debug overlay GeoJSON endpoints).
 *
 * Auth: in dev (`import.meta.env.DEV`) sends the `DEV_MODE_TOKEN`, in prod
 * pulls the Cognito access token from `localStorage` like the GraphQL link.
 * Operation: reads from the operation Pinia store; omitted if no operation.
 */
export async function authedFetch(input: string, init: RequestInit = {}): Promise<Response> {
    const headers: Record<string, string> = {
        ...(init.headers as Record<string, string> | undefined),
    };

    const isDev = import.meta.env.DEV;
    if (isDev) {
        headers['Authorization'] = 'Bearer DEV_MODE_TOKEN';
    } else {
        const token = localStorage.getItem('access-token');
        if (token) headers['Authorization'] = `Bearer ${token}`;
    }

    try {
        const operationId = useOperationStore().currentOperationId;
        if (operationId) headers['X-Operation-Id'] = operationId;
    } catch {
        // Pinia not yet initialized — fine, just omit the header.
    }

    if (init.body && !headers['Content-Type']) {
        headers['Content-Type'] = 'application/json';
    }

    return fetch(input, { ...init, headers });
}
